import api from '@api';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getOrdersGridFetch } from '../ordersGrid/reducer';
import { getClaimsGridFetch } from '../claimsGrid/reducer';
import { ClaimType } from '../../types/claim';
import {
    patchClaimFetchFailure,
    patchClaimFetchSuccess,
    patchMultipleClaimsFetchFailure,
    patchMultipleClaimsFetchSuccess
} from './reducer';

const patchOrderFetchRequest = async (claim: ClaimType, data: ClaimType) => {
    const res = await api('patch', `api/secure/claims/${claim.ID}`, data, {forceEshopKey: claim.ESHOP_KEY});
    return res.data;
};

function* patchOrderFetch(action: { type: string; payload: { claim: ClaimType; data: ClaimType } }) {
    const { claim, data } = action.payload;

    try {
        yield call((): any => patchOrderFetchRequest(claim, data));
        yield put(patchClaimFetchSuccess());
    } catch (error) {
        yield put(patchClaimFetchFailure({ error }));
    }
}

export function* patchClaimFetchWatch() {
    yield takeEvery('claimsUpdate/patchClaimFetch', patchOrderFetch);
}

function* patchMultipleClaimsFetch(action: { type: string; payload: { claims: ClaimType[]; data: ClaimType } }) {
    const { claims, data } = action.payload;
    const batchSize = 10; // Nastav velikost stránky (počet claimů na jednu dávku)

    try {
        // Rozdělení claims na menší dávky
        for (let i = 0; i < claims.length; i += batchSize) {
            const chunk = claims.slice(i, i + batchSize);

            // Zpracování každé dávky samostatně
            yield all(
                chunk.map((claim) =>
                    call(patchOrderFetch, { type: 'claimsUpdate/patchClaimFetch', payload: { claim, data } })
                )
            );
        }

        yield put(patchMultipleClaimsFetchSuccess());
        yield put(getClaimsGridFetch(undefined));
    } catch (error) {
        yield put(patchMultipleClaimsFetchFailure({ error }));
        yield put(getClaimsGridFetch(undefined));
    }
}

export function* patchMultipleClaimsFetchWatch() {
    yield takeEvery('claimsUpdate/patchMultipleClaimsFetch', patchMultipleClaimsFetch);
}
